/**
 * Одноразовый запрос геопозиции для аварийного маршрута «от моего места до
 * ближайшего укрытия» (запрос владельца 27.07): когда наших дорожек к укрытию
 * нет, путь строит внешний навигатор от текущей позиции — а для этого нужна
 * позиция. Уже известную (кэш `geoStart`) не перезапрашиваем, промпт не дёргаем.
 */
import type { LonLat } from '@app/geo'
import { geoStart } from '../state'

/** Ждём геопозицию: кэш → getCurrentPosition (с промптом). null — нет/отказ. */
export function ensureGeoStart(): Promise<LonLat | null> {
  if (geoStart.value) return Promise.resolve(geoStart.value)
  if (!navigator.geolocation) return Promise.resolve(null)
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const p: LonLat = [pos.coords.longitude, pos.coords.latitude]
        geoStart.value = p
        resolve(p)
      },
      () => resolve(null),
      { enableHighAccuracy: true, maximumAge: 30_000, timeout: 8_000 },
    )
  })
}
